import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import debounce from "@frameworks/web/utils/debounce";
import di from "../di/servicelocator";
import CommonSortDropMob from "@frameworks/web/components/Reports/CommonComponent/CommonSortDropMob";
import CommonFilterAssetDropMob from "@frameworks/web/components/Reports/CommonComponent/CommonFilterAssetDropMob";
import Drawer from "react-bottom-drawer";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { ESortOrder } from "@domains/utils/sort";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import _ from "underscore";
const PnLDownloadSortFilterMob = (props) => {
    var _a;
    const navigate = useNavigate();
    const [showSearch, setShowSearch] = React.useState(false);
    const [orderBy, setOrderBy] = React.useState(0);
    const [showFilterAssetDrop, setShowFilterAssetDrop] = React.useState(false);
    const [showSortDrop, setShowSortDrop] = React.useState(false);
    const filters = useSelector((state) => { var _a, _b; return (_b = (_a = state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.FilterData; });
    const showShimmer = useSelector((state) => state === null || state === void 0 ? void 0 : state.pnlReport.showShimmer);
    const PNLStreamFromStore = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.stream; }, _.isEqual);
    const pnlDetails = useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.PnLData) === null || _c === void 0 ? void 0 : _c.pnLDetails; });
    const [filterData, setFilterData] = React.useState(filters);
    const openDrawerFilterAsset = React.useCallback(() => setShowFilterAssetDrop(true), []);
    const closeDrawerFilterAsset = React.useCallback(() => setShowFilterAssetDrop(false), []);
    const openDrawerSort = React.useCallback(() => setShowSortDrop(true), []);
    const closeDrawerSort = React.useCallback(() => setShowSortDrop(false), []);
    const formattedFromDate = moment(props.fromDate).format("yyyy-MM-DD");
    const formattedToDate = moment(props.toDate).format("yyyy-MM-DD");
    const baseUrl = `/pnlDownload?fromDate=${formattedFromDate}&toDate=${formattedToDate}&assetType=${props.assetType}&duration=${props.duration}`;
    const pnlRedirectUrl = props.accCode
        ? `${baseUrl}&family=${window.btoa(props.accCode)}`
        : baseUrl;
    const sortKeyDisplayState = {
        Alphabetical: { asc: "Z to A", desc: "A to Z" },
        "P&L %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "P&L absolute": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Realized P&L %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Realized P&L abs": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Unrealized P&L %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Unrealized P&L abs": {
            asc: "Lowest to Highest",
            desc: "Highest to Lowest",
        },
    };
    const handleSearchInput = (e) => {
        props.setSearchVal(e.target.value);
        debounce(() => {
            di.pnlReport.getSearchPNLReportData(e.target.value, props.tabName);
        }, 300)();
    };
    const sortData = useSelector((state) => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.SortData; });
    const [sortByFilters, setSortByFilters] = useState(sortData);
    const pnlReportError = useSelector((state) => state === null || state === void 0 ? void 0 : state.pnlReport.errorData);
    const emptyValidation = useSelector((state) => state === null || state === void 0 ? void 0 : state.pnlReport.emptyValidation);
    useEffect(() => {
        setFilterData(filters);
    }, [showFilterAssetDrop]);
    useEffect(() => {
        setSortByFilters(sortData);
    }, [sortData]);
    useEffect(() => {
        setFilterData(filters);
    }, [filters]);
    const resetSearch = () => {
        props.setSearchVal("");
        di.pnlReport.getSearchPNLReportData("", props.tabName);
    };
    const hideSearch = async () => {
        setShowSearch(false);
        props.setSearchVal("");
        await di.pnlReport.getSearchPNLReportData("", props.tabName);
    };
    useEffect(() => {
        props.setShowSearchParent(showSearch);
    });
    const wrapperRef = React.useRef(null);
    const sortByFunction = (idx, sortState) => {
        setSortByFilters(sortState);
        const sort = sortState[idx];
        // const sort = new SortData(displayName, sortName, newOrder);
        di.pnlReport.getSortedPNLReportData(sort, true, props.tabName);
        //set red dot on sort function
        props.setSortoptionSelected(true);
        setShowSortDrop(false);
    };
    const applyFilter = () => {
        // props.setShimmer(true);
        di.pnlReport.getFilteredPNLReportData(filterData, props.tabName);
    };
    const closeSearch = () => {
        if (!props.searchVal)
            setShowSearch(false);
    };
    const resetSort = () => {
        di.pnlReport.getSortedPNLReportData({
            displayName: "Alphabetical",
            order: ESortOrder.DESC,
            sortName: "displayName",
        }, false, props.tabName);
        let newSortState = sortByFilters.map((val, i) => {
            i === 0
                ? (val.order = ESortOrder.DESC)
                : (val.order = ESortOrder.UNCHANGED);
            return val;
        });
        setSortByFilters(newSortState);
        //set red dot on sort function
        props.setSortoptionSelected(false);
        setShowSortDrop(false);
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "summarize-pnl d-flex justify-content-between" },
            React.createElement("div", { className: "summarize" },
                React.createElement("label", { className: "custom-control border-switch" },
                    React.createElement("input", { type: "checkbox", className: "border-switch-control-input", defaultChecked: props.isSummarize, disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                            (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                            showShimmer, onChange: (e) => {
                            var _a;
                            di.pnlReport.getSummarizePNLReportData((_a = e.target) === null || _a === void 0 ? void 0 : _a.checked, props.tabName);
                        } }),
                    React.createElement("span", { className: "border-switch-control-indicator" }),
                    React.createElement("span", { className: "teleport-switch-control-description" }, "Summarize Values"))),
            React.createElement("div", { className: "summarize" },
                React.createElement("label", { className: "custom-control border-switch" },
                    React.createElement("input", { type: "checkbox", className: "border-switch-control-input", onClick: () => {
                            di.pnlReport.pnlToggleStream(!PNLStreamFromStore);
                        }, defaultChecked: PNLStreamFromStore, disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                            (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                            showShimmer }),
                    props.assetType !== "PMS" &&
                        props.assetType !== "MF" &&
                        props.assetType !== "AIF" ? (React.createElement(React.Fragment, null,
                        " ",
                        React.createElement("span", { className: "border-switch-control-indicator" }),
                        " ",
                        React.createElement("span", { className: "teleport-switch-control-description" },
                            " ",
                            "Stream"),
                        " ")) : (React.createElement(React.Fragment, null))))),
        React.createElement("div", { className: `filter-wrapper
      ${showSearch && props.scrollPosition > 100 ? "dock-filterbar-mob-pnl" : ""} `, style: { padding: "7px 0px" } },
            React.createElement("div", { className: "searchbar-c searchbar-c-new", style: { width: "85%", height: "36px" } },
                React.createElement("label", { htmlFor: showSearch ? "focus-input" : "" }, showSearch ? (React.createElement("i", { className: `edel-icon-left-arrow  ${showSearch ? "bg-white left-thin-arrow-expand" : ""}`, onClick: hideSearch })) : (React.createElement("i", { className: "edel-icon-bold-search", onClick: () => {
                        if (!((pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                            (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL]
                                    .icon ||
                            showShimmer))
                            setShowSearch(true);
                    } }))),
                React.createElement("input", { id: "focus-input", type: "search", className: `${showSearch ? " bg-white p-10" : ""}`, name: "search", onChange: handleSearchInput, value: props.searchVal, onFocus: () => setShowSearch(true), onBlur: closeSearch, autoComplete: "off", disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                        (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                            EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                        showShimmer }),
                showSearch && (React.createElement("label", { htmlFor: "focus-input" },
                    React.createElement("i", { className: `edel-icon-close ${showSearch ? "close-expand bg-white" : ""}  `, onClick: resetSearch })))),
            React.createElement("div", { className: "sort" },
                React.createElement("button", { className: "btn  sorting sort-btn", onClick: openDrawerSort, disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                        (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                            EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                        showShimmer },
                    React.createElement("i", { className: "edel-icon-sort sort-filter-icon" }, props.sortOptionSelected && ((_a = sortByFilters[0]) === null || _a === void 0 ? void 0 : _a.order) != -1 && (React.createElement("span", { className: "sort-filter-selected" })))),
                React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerSort, isVisible: showSortDrop, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
                    React.createElement(CommonSortDropMob, { OrderBy: orderBy, setOrderBy: setOrderBy, sortByFilters: sortByFilters, setSortByFilters: setSortByFilters, sortKeyDisplayState: sortKeyDisplayState, sortByFunction: sortByFunction, resetSort: resetSort }))),
            React.createElement("div", { className: "filter" },
                React.createElement("button", { className: "btn filter filter-btn", onClick: openDrawerFilterAsset, disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                        (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                            EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                        showShimmer },
                    React.createElement("i", { className: "edel-icon-curved-filter filter-icon" }, props.showFDot > 0 && React.createElement("span", { className: "filter-selected" }))),
                React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerFilterAsset, isVisible: showFilterAssetDrop, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
                    React.createElement(CommonFilterAssetDropMob, { setShowFilterAssetDrop: setShowFilterAssetDrop, setShowDot: props.setShowFDot, filterData: filterData, setFilterData: setFilterData, applyFilter: applyFilter, showAsset: false, clearSessionFilters: di.pnlReport.removeSessionFilters }))),
            React.createElement("div", { className: "downloads" },
                React.createElement("button", { className: "btn  download download-btn", disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                        (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                            EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                        showShimmer, onClick: () => {
                        navigate(pnlRedirectUrl, { replace: true });
                    } },
                    React.createElement("i", { className: "edel-icon-bold-download" }))))));
};
export default PnLDownloadSortFilterMob;
